module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/food/fish-81e158381709a27225d0344a3c0c6db1.svg";